import ramdaIsEmpty from 'ramda/es/isEmpty';
import isNil from 'ramda/es/isNil';

const isEmpty = val => ramdaIsEmpty(val) || isNil(val);

export default isEmpty;
